<template>
  <div class="mix-list">
    <div v-if="state === 'loading'" class="d-flex justify-content-center py-5">
      <span class="spinner-border" role="status" aria-label="Loading"></span>
    </div>
    <template v-else>
      <mix-list :mixes="mixes" class="vue-mix-list" />
      <share-accept v-if="currentShare" :share="currentShare" />
    </template>
  </div>
</template>

<script>
import MixList from '../mix_list.vue'
import ShareAccept from '../share_accept.vue'
import { mixesStore } from '../path_store'

export default {
  data() {
    return { initialized: false }
  },
  components: { MixList, ShareAccept },
  watch: {
    '$route': {
      handler(to) {
        if ( !this.initialized ) {
          this.initialized = true
          mixesStore.init(window.mbPreload?.mixes)
        } else {
          mixesStore.setPath(to.path)
        }
      },
      immediate: true
    }
  },
  computed: {
    mixes() { return mixesStore.items },
    state() { return mixesStore.pathState },
    currentShare() { return window.mbPreload?.currentShare }
  }
}
</script>
